import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Layout from '~/src/layout/_layout';
import { Telephone } from '~/src/layout/telephone';
import { getSalePackages, EExpand } from '~/src/api/content/sale-packages';
import * as base from '~/src/helpers/basePageFunc';
import ErrorPage from '~/pages/_error';

class TelephonePage extends Component {
    static propTypes = {
        city: PropTypes.object,
        telephoneTariff: PropTypes.object,
        hostname: PropTypes.string,
    };

    static defaultProps = {
        city: {},
        telephoneTariff: null,
    }

    static async getInitialProps(options) {
        const { hostname } = await base.initialProps(options);
        const { store, res } = options;
        const state = store.getState();
        const domain = state.city.currentCity.domain;
        const tariffs = await getSalePackages(domain, [EExpand.tel]);
        const tariffWithTelephone = tariffs.find(item => (!!item.telephonyTariff && !!item.telephonyTariff.length));
        const telephoneTariff = tariffWithTelephone && tariffWithTelephone.telephonyTariff[0];

        if (!telephoneTariff) {
 res.statusCode = 404;
}
        return { hostname, telephoneTariff };
    }

    render() {
        const { city, hostname, telephoneTariff } = this.props;
        const cityText = city.cityIn;

        if (!telephoneTariff) {
            return <ErrorPage statusCode={404}/>;
        }

        return (
            <Layout
                title={`Подключить домашний телефон от Дом.ru в ${cityText} | Установка городского телефона в квартиру`}
                description={`Провайдер Дом.ru предлагает подключить городской домашний телефон в ${cityText}. Проведем и установим стационарный телефон в квартиру. Оставьте заявку на сайте или по ☎ ${city.phone}.`}
                hostname={hostname}
                withMenu={true}
                withChat={true}
                withFooter={true}
                relCanonical={`https://${hostname}/telephone`}
            >
                <Telephone tariffsData={telephoneTariff} city={city}/>
            </Layout >
        );
    }
}

const mapStateToProps = (state) => ({
    city: get(state, 'city.currentCity'),
});

export default connect(mapStateToProps)(TelephonePage);
